// extracted by mini-css-extract-plugin
export default {"iconContainer":"SingleModalFilter_iconContainer__b5e0P"};